import { useMemo, useRef } from 'react';
import { atom } from 'jotai';
import type { ActionT } from '../../labelling/reducers/actions';
import type { ActionT as ModernisedAction } from '../actions';
import { dispatchAtom } from '../atoms/label-store-dispatch/dispatch';
import type { StudioEvent } from '../atoms/label-store-dispatch/events';
import { EVENTS } from '../atoms/label-store-dispatch/events';
import { PERFORMANCE_METRIC_EVENTS } from '../constants/performance';
import { useMeasurePaintLatency } from './performance/use-measure-paint-latency';
type MergedAction = ActionT | ModernisedAction;
export function useStageDispatchAtom() {
  const measurePaintLatency = useMeasurePaintLatency({
    throttleMs: 0
  });
  const measureRef = useRef(measurePaintLatency);
  // eslint-disable-next-line react-hooks/refs
  measureRef.current = measurePaintLatency;
  return useMemo(() =>
  // eslint-disable-next-line react-hooks/refs
  atom(undefined, (_get, set, action: MergedAction | StudioEvent) => {
    if (action.type === EVENTS.SELECT_ANNOTATION) {
      measureRef.current(PERFORMANCE_METRIC_EVENTS.ANNOTATION_SELECT_TO_PAINT, () => set(dispatchAtom, action));
    } else if (action.type === EVENTS.FOCUS_ANNOTATION) {
      measureRef.current(PERFORMANCE_METRIC_EVENTS.ANNOTATION_HOVER_TO_PAINT, () => set(dispatchAtom, action));
    } else {
      set(dispatchAtom, action);
    }
  }), []);
}